import {Logos} from './Logos';
import {Testimonials} from './Testimonials';

export const SignInAside = () => (
  <div>
    <Testimonials />
    <Logos />
  </div>
);
